import React from 'react';
import { Section } from './Section';
import { reasons } from '../data/content';
export function Reasons() {
  return <Section title="5 razones reales" data-id="element-78" data-mp="216e9h6qveccz">
      <ol className="divide-y divide-ink-line border-t border-ink-line" data-id="element-79" data-mp="219il2p6o0ado">
        {reasons.map((reason, index) => <li key={reason.title} className="grid grid-cols-1 gap-4 py-8 md:grid-cols-12 md:gap-8" data-id="element-80" data-mp="2b5lsa9gdiz7h" data-mpi={index}>
            <div className="md:col-span-1" data-id="element-81" data-mp="1dhv1ksbqg1lf">
              <span className="font-serif text-3xl leading-none text-terracotta" data-id="element-82" data-mp="1dj65qt93bbd2">{index + 1}</span>
            </div>
            <div className="md:col-span-11" data-id="element-83" data-mp="1ih7qrjq2tkr6">
              <h3 className="text-xl font-semibold text-ink md:text-2xl" data-id="element-84" data-mp="1ngat2weo9cvg">{reason.title}</h3>
              <div className="mt-3 space-y-1.5 text-lg leading-relaxed text-ink-soft" data-id="element-85" data-mp="1s6hiuzkx73fa">
                {reason.lines.map(line => <p key={line} data-id="element-86" data-mp="uqbzqotg2tkz">{line}</p>)}
              </div>
            </div>
          </li>)}
      </ol>
    </Section>;
}